<div class="form-header">
  <div class="form-header__content">
    <h2 class="title">{{ title() }}</h2>
    @if (cropFieldName()) {
      <div>
        @if (isMobileOrTablet()) {
          <span>{{ cropFieldName() }} / {{ cropFieldArea() | number: '1.2' }} ha</span>
        } @else {
          <span>{{ cropFieldName() }}</span>
          <span class="text-gray"> {{ cropFieldArea() | number: '1.2' }} ha {{ cropFieldCrop() }} </span>
        }
      </div>
    }
  </div>
  <app-crop-year-selector class="form-header__selector" [readOnly]="true" />
</div>
